export const API = {
  POST: {
    LOOKUP_GET: "/v1/lookup/get",
    FORNITORI_ADD: "/v1/fornitori",
    GRUPPI_FORNITORI_ADD: "/v1/gruppi-fornitori",
    GRUPPI_FORNITORI_AGGIUNGI_FORNITORE: "/v1/gruppi-fornitori/{id}/fornitori",
    FORNITORI_DOWNLOAD_ZIP: "v1/export/fornitori/zip"
  },
  GET: {
    SISTEMA_MENU_GET: "/v1/sistema/menu/get",
    OPTIONS_VALUES: "/v1/options-values",

    FORNITORI_LIST: "/v1/fornitori",
    FORNITORI_VIEW: "/v1/fornitori",
    FORNITORI_EXTENDED: "/v1/fornitori-extended",
    FORNITORI_IMPORTA_CERVED: "/v1/fornitori/{id}/cerved",
    FORNITORI_GRUPPI: "/v1/fornitori/{id}/gruppi",

    GRUPPI_FORNITORI_LIST: "/v1/gruppi-fornitori",
    GRUPPI_FORNITORI_VIEW: "/v1/gruppi-fornitori",
    GRUPPI_FORNITORI_FORNITORI: "/v1/gruppi-fornitori/{id}/fornitori",
  },
  PUT: {
    FORNITORI_EDIT: "/v1/fornitori",
    FORNITORI_GRUPPI: "/v1/fornitori/{id}/gruppi",
    GRUPPI_FORNITORI_EDIT: "/v1/gruppi-fornitori",
  },
  PATCH: {
    FORNITORI_GRUPPI: "/v1/fornitori/{id}/gruppi",
  },
  EDIT: {
    FORNITORI_EDIT: "/v1/fornitori",
    GRUPPI_FORNITORI_EDIT: "/v1/gruppi-fornitori",
  },
  DELETE: {
    FORNITORI_DELETE: "/v1/fornitori",
    GRUPPI_FORNITORI_DELETE: "/v1/gruppi-fornitori",
    GRUPPI_FORNITORI_RIMUOVI_FORNITORE: "/v1/gruppi-fornitori/{idGruppo}/fornitori/{idFornitore}",
  },
} as const;

/**
 * Mock responses per le API - Ora gestito dal sistema di mock avanzato
 *
 * @deprecated I mock sono stati spostati nel sistema modulare in src/mocks/api/
 * Questo oggetto è mantenuto solo per retrocompatibilità temporanea.
 *
 * Per utilizzare i nuovi mock:
 * import { API_MOCKS } from '@/mocks/api';
 */
export const MOCK_RESPONSES = {
  // I mock sono ora gestiti dal sistema modulare in src/mocks/api/
  // Questo file mantiene solo le costanti per gli endpoint
} as const;
